import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
export function BlotterPanelBodyLayout({ children }: Props) {
  return <div className="card-body overflow-auto">{children}</div>;
}
